import React, { Component } from 'react';
import { Alert, Intent } from '@blueprintjs/core';

class DeleteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            data: {}
        };
        this.openModal = this.openModal.bind(this);
    }
    componentDidMount() {
        window.addEventListener('open-delete-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-delete-modal', this.openModal);
    }
    openModal = event => {
        const { detail } = event;
        this.setState({
            showModal: true,
            data: detail
        });
    }
    closeModal = () => {
        this.setState({ showModal: false, data: {} });
    }
    onDelete = () => {
        const { data: { onDelete }} = this.state;
        onDelete();
        this.closeModal();
    }
    render() {
        const { showModal, data: { content }} = this.state;
        return (
            <Alert cancelButtonText='Cancel'
                confirmButtonText='Delete'
                icon='trash'
                intent={Intent.DANGER}
                isOpen={showModal}
                onCancel={this.closeModal}
                onConfirm={this.onDelete}>
                {content}
            </Alert>
        );
    }
}

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/widgets/DeleteModal.jsx